import React from 'react';
import { Button, Text, Tooltip, makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    root: {
        color: '#ffffff',
        borderRadius: '12px',
        padding: '12px 20px',
        backgroundColor: 'rgba(30, 30, 30, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        width: '100%',
        cursor: 'pointer',
        transition: 'border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            borderTopColor: 'rgba(0, 200, 80, 0.5)',
            borderRightColor: 'rgba(0, 200, 80, 0.5)',
            borderBottomColor: 'rgba(0, 200, 80, 0.5)',
            borderLeftColor: 'rgba(0, 200, 80, 0.5)',
            backgroundColor: 'rgba(34, 45, 35, 0.5)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        },
        '&:disabled': {
            opacity: 0.5,
            color: '#ffffff',
            cursor: 'not-allowed',
            borderTopColor: 'transparent',
            borderRightColor: 'transparent',
            borderBottomColor: 'transparent',
            borderLeftColor: 'transparent',
            backgroundColor: 'rgba(30, 30, 30, 0.5)',
            boxShadow: 'none',
        },
    },
    highlighted: {
        borderTopColor: 'rgba(0, 200, 80, 0.4)',
        borderRightColor: 'rgba(0, 200, 80, 0.4)',
        borderBottomColor: 'rgba(0, 200, 80, 0.4)',
        borderLeftColor: 'rgba(0, 200, 80, 0.4)',
        '&:hover': {
            borderTopColor: 'rgba(0, 255, 0, 0.6)',
            borderRightColor: 'rgba(0, 255, 0, 0.6)',
            borderBottomColor: 'rgba(0, 255, 0, 0.6)',
            borderLeftColor: 'rgba(0, 255, 0, 0.6)',
        },
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '6px',
    },
    iconTextContainer: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '8px',
    },
    titleText: {
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
    },
    subtitleText: {
        fontWeight: 'normal',
        fontSize: '13px',
        color: '#cccccc',
    },
});

interface SampleQueryCardProps {
    title: string;
    description: string;
    icon: string;
    highlighted?: boolean;
    disabled?: boolean;
    disabledTooltip?: string;
    onClick?: () => void;
}

const SampleQueryCard: React.FC<SampleQueryCardProps> = ({
    title,
    description,
    icon,
    highlighted,
    disabled,
    disabledTooltip,
    onClick,
}) => {
    const classes = useStyles();

    const button = (
        <Button
            className={`${classes.root} ${highlighted ? classes.highlighted : ''}`}
            disabled={disabled}
            onClick={onClick}
        >
            <div className={classes.iconContainer}>
                {icon}
                <div className={classes.iconTextContainer}>
                    <Text className={classes.titleText}>{title}</Text>
                </div>
            </div>
            <Text className={classes.subtitleText}>{description}</Text>
        </Button>
    );

    if (disabled && disabledTooltip) {
        return (
            <Tooltip
                content={disabledTooltip}
                relationship="description"
                positioning="above-start"
                withArrow={true}
            >
                {button}
            </Tooltip>
        );
    }

    return button;
};

export default SampleQueryCard;
